import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import paymentReducer from './slices/paymentSlice';
import orderReducer from './slices/orderSlice';
import onboardingReducer from './slices/onboardingSlice';
import cardReducer from './slices/cardSlice';
import uiReducer from './slices/uiSlice';
import balanceReducer from './slices/balanceSlice';
import refundReducer from './slices/refundSlice';
import disputeReducer from './slices/disputeSlice';
import treasuryReducer from './slices/treasurySlice';
import paymentLinkReducer from './slices/paymentLinkSlice';
import reportReducer from './slices/reportSlice';
import notificationReducer from './slices/notificationSlice';
import channelReducer from './slices/channelSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    payment: paymentReducer,
    order: orderReducer,
    onboarding: onboardingReducer,
    card: cardReducer,
    ui: uiReducer,
    balance: balanceReducer,
    refund: refundReducer,
    dispute: disputeReducer,
    treasury: treasuryReducer,
    paymentLink: paymentLinkReducer,
    report: reportReducer,
    notification: notificationReducer,
    channel: channelReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 